export enum NotificationActionType {
  CreateFtForm = 0,
  ProcessFtFormStep = 1,
  OpenDashboard = 2,
  FollowLink = 4,
  TakeQuiz = 5,
  ProcessQuizStep = 6,
  ProcessPeFormStep = 7,
  LateQuizOpenDashboard = 9,
  ProcessPpFormStep = 10,
  CreatePeForm = 11,
  CreatePpForm = 12,
  OpenHighFive = 13,
  OpenFtFormInstance = 14,
  OpenPeFormInstance = 15,
  OpenPpFormInstance = 16,
  OpenTrainingCourseClass = 17
}
